import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import Heading from 'LuxKit/Typography/Heading'
import { rem } from 'polished'
import styled from 'styled-components'

const Container = styled(Group)`
  flex: 1;
  padding: ${rem(20)} 0;

  ${mediaQueryUp.desktop} {
    padding: ${rem(40)} 0;
  }
`

interface Props {
  detailName: string
  title: string
  icon: React.ReactNode
  subtitle?: string
  note?: string
}

function WeddingDayDetail(props: Props) {
  const { detailName, title, icon, subtitle, note } = props

  return (
    <Container direction="vertical" gap={20} horizontalAlign="center">
      {icon}
      <Group direction="vertical" gap={8} horizontalAlign="center">
        <Caption variant="small" weight="bold" format="uppercase" align="center" colour="light-foreground-alt">{detailName}</Caption>
        <Heading variant="heading3alt" align="center">{title}</Heading>
        {subtitle && <Heading variant="heading6" align="center" colour="light-foreground-alt">{subtitle}</Heading>}
      </Group>
      {note && <BodyText variant="medium" align="center" colour="light-foreground-alt">{note}</BodyText>}
    </Container>
  )
}

export default WeddingDayDetail
